import { formControlFocusRing } from '@mangovoice/design-system/recipes/focusRing'

import { dsText, fontSize, tokenVar } from '../../utils'

export const scheduleModalLabelStyles = {
  fontFamily: dsText.Body1_Bold.fontFamily,
  fontSize: fontSize(dsText.Body1_Bold.fontSize),
  fontWeight: dsText.Body1_Bold.fontWeight,
  lineHeight: dsText.Body1_Bold.lineHeight,
  color: tokenVar('fg.default'),
}

export const scheduleModalBodyTextStyles = {
  fontFamily: dsText.Body1.fontFamily,
  fontSize: fontSize(dsText.Body1.fontSize),
  fontWeight: dsText.Body1.fontWeight,
  lineHeight: dsText.Body1.lineHeight,
  color: tokenVar('fg.muted'),
}

export const scheduleModalInputStyles = {
  minH: '44px',
  borderWidth: '1px',
  borderColor: tokenVar('border.default'),
  borderRadius: '8px',
  bg: tokenVar('bg.muted'),
  color: tokenVar('fg.default'),
  fontFamily: dsText.Body2.fontFamily,
  fontSize: fontSize(dsText.Body2.fontSize),
  fontWeight: dsText.Body2.fontWeight,
  lineHeight: dsText.Body2.lineHeight,
  _placeholder: {
    color: tokenVar('fg.subtle'),
  },
  ...formControlFocusRing,
  _focusVisible: {
    ...formControlFocusRing._focusVisible,
    bg: tokenVar('brand.subtle'),
  },
}

export const scheduleModalInvalidInputStyles = {
  _invalid: {
    borderColor: tokenVar('fg.error'),
  },
}

/**
 * `formControlFocusRing` for a wrapper around a field and its buttons, drawn
 * like Chakra's inside ring while any child has focus.
 */
export const scheduleModalFieldGroupFocusStyles = {
  _focusWithin: {
    ...formControlFocusRing._focusVisible,
    outlineOffset: '0px',
    outlineWidth: 'var(--focus-ring-width)',
    outlineStyle: 'solid',
    outlineColor: 'var(--focus-ring-color)',
    borderColor: 'var(--focus-ring-color)',
    bg: tokenVar('brand.subtle'),
  },
}

export const scheduleModalOptionLabelStyles = {
  fontFamily: dsText.Body1.fontFamily,
  fontSize: fontSize(dsText.Body1.fontSize),
  fontWeight: dsText.Body1.fontWeight,
  lineHeight: dsText.Body1.lineHeight,
  color: tokenVar('fg.default'),
}
